module.exports = __webpack_public_path__ + "img/noData.eb85ec82.png";